import React, { useState } from 'react';
import AkoyaView from './Akoya.view';

const renderOption = (fiId) => (
  <option key={fiId} value={fiId}>{ fiId }</option>
);

export default function AkoyaSelector({
  fiIds,
  handleNextClick,
}) {
  const [selectedFiId, setSelectedFiId] = useState();
  const handleChange = (event) => {
    setSelectedFiId(event.target.value);
  };
  return (
    <AkoyaView
      handleNextClick={() => handleNextClick(selectedFiId)}
    >
      { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
      <label>
        Choose your financial institution:
        <select name="selectedProviderId" onChange={handleChange}>
          <option>Choose Your Bank</option>
          { fiIds.map(renderOption) }
        </select>
      </label>
    </AkoyaView>
  );
}
